import { render, staticRenderFns } from "./switch-widget.vue?vue&type=template&id=7a1978f2&scoped=true"
import script from "./switch-widget.vue?vue&type=script&lang=js"
export * from "./switch-widget.vue?vue&type=script&lang=js"
import style0 from "./switch-widget.vue?vue&type=style&index=0&id=7a1978f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1978f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a1978f2')) {
      api.createRecord('7a1978f2', component.options)
    } else {
      api.reload('7a1978f2', component.options)
    }
    module.hot.accept("./switch-widget.vue?vue&type=template&id=7a1978f2&scoped=true", function () {
      api.rerender('7a1978f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/switch-widget.vue"
export default component.exports